import { RawCollection } from '../types';

interface AddItemToCollectionCacheProps {
    collectionId: string;
    item: RawCollection['items'][number];
    itemIndex?: number;
}

export const addItemToCollectionCache = (
    oldData: RawCollection[],
    { collectionId, item, itemIndex }: AddItemToCollectionCacheProps
): { newData: RawCollection[] } => {
    const newData = oldData.map((collection: RawCollection) => {
        if (collection.id !== collectionId) {
            return collection;
        }

        const newItems = [...collection.items];
        newItems.splice(itemIndex ?? newItems.length, 0, item);

        return {
            ...collection,
            items: newItems,
        };
    });

    return { newData };
};
